// src/plugins/fontawesome.js
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import whichever icons you need:
import {
    faBars,
    faWifi,
    faGear,
    faXmark,
    faPlus,
    faPaperPlane,
    faTrash,
    faMagnifyingGlass,
    faFilter,
    faCog,
    faCalendarDays,
    faNetworkWired,
    faLaptop,
    faChartColumn,
    faBan,
    faHouseMedical,
    faAnglesRight,
    faAnglesLeft,
    faMobileScreenButton,
    faCircleInfo,
    faChevronRight,
    faChevronDown,
    faPen,
    faTrashCan,
    faTimes,
    faMobile,
    faDesktop,
    faVideo,
    faExclamationTriangle,
    faZap,
    faCheck,
    faExclamation,
    faGauge,
    faSquareCheck,
    faBell as faBellSolid,
    faUsers,
    faHome,
    faArrowLeft,
    faFlag,
    faCopy,
    faPlay,
    faSpinner,
    faDownload,
    faUpload,
    faClock,
    faSun,
    faMoon,
    faAdjust,
    faPhone,
    faEnvelope,
    faStar,
    faLock,
    faRobot,
    faRocket,
    faComments,
    faShieldAlt,
    faChartLine,
    faCreditCard,
    faUniversity,
} from '@fortawesome/free-solid-svg-icons'
import {
    faBell as faBellRegular,
    faUser,
    faSquare,
} from '@fortawesome/free-regular-svg-icons'
import {
    faVuejs,
    faFacebook,
    faYoutube,
    faInstagram,
    faTiktok,
} from '@fortawesome/free-brands-svg-icons'

// add them to the library
library.add(
    faUser,
    faVuejs,
    faBars,
    faWifi,
    faBellSolid,
    faBellRegular,
    faGear,
    faPlus,
    faCog,
    faXmark,
    faPaperPlane,
    faFacebook,
    faYoutube,
    faTrash,
    faMagnifyingGlass,
    faFilter,
    faCalendarDays,
    faNetworkWired,
    faLaptop,
    faChartColumn,
    faBan,
    faHouseMedical,
    faAnglesRight,
    faAnglesLeft,
    faMobileScreenButton,
    faCircleInfo,
    faChevronRight,
    faChevronDown,
    faPen,
    faTrashCan,
    faTimes,
    faChevronDown,
    faZap,
    faExclamationTriangle,
    faMobile,
    faDesktop,
    faVideo,
    faCheck,
    faExclamation,
    faGauge,
    faSquareCheck,
    faSquare,
    faUsers,
    faInstagram,
    faTiktok,
    faHome,
    faArrowLeft,
    faFlag,
    faCopy,
    faPlay,
    faSpinner,
    faDownload,
    faUpload,
    faClock,
    faSun,
    faMoon,
    faAdjust,
    faPhone,
    faEnvelope,
    faStar,
    faLock,
    faRobot,
    faRocket,
    faComments,
    faShieldAlt,
    faChartLine,
    faCreditCard,
    faUniversity,
)

// register the component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)
